<div class="content_wrap_section">
    <div class="wrap_header_sectons">
        <div class="top_header_overlay"></div>
        <h1>Trabalhe Conosco</h1>
    </div>

    <div class="about_us_wrap">
        <div class="container">
            <div class="row">
                <div class="con-md-12">
                    <div class="about_us_right_contents padding_left_side work_with_us_contents">
                        <h3>Continuamos empurrando os limites</h3>
                        <p>Somos uma equipe de 20 pessoas apaixonadas que acreditam em ir além do estado da arte e nunca dizer não a um desafio. Fizemos vários avanços no processamento de linguagem natural e na tecnologia de IA para aprimoramento de linguagem. E não estamos a abrandar. Se você está pronto para um desafio, <a href="https://www.crimsoni.ai/work-with-us.htm" target="_blank"> junte-se a nós!</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>